import { Outlet } from 'react-router-dom';

export const PublicRoute = () => {
  return <Outlet />;
};
